import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import StoreContext from '../../react-core-lib/components/app/store-context';

const BANNER_MESSAGES = {
    Free: {
        prefix: 'Upgrade now',
        suffix: ' for as little as £9.99 /month to unlock all features',
    },
    Student: {
        prefix: 'Upgrade now',
        suffix: ' for as little as £9.99 /month to unlock all features',
    },
    Professional: {
        prefix: 'Upgrade now',
        suffix: ' for clinic-wide access and advanced features!',
    },
};

const AnnouncementBanner = observer(() => {
    const navigate = useNavigate();
    const { userDataStore } = useContext(StoreContext);
    const accountType = userDataStore?.subscriptionData?.accountType;

    const message = BANNER_MESSAGES[accountType];

    if (!message) {
        return null;
    }

    const handleClick = () => {
        navigate('/settings/manage-subscription');
    };

    return (
        <Box
            onClick={handleClick}
            sx={{
                width: '100%',
                backgroundColor: '#000453',
                height: { xs: '40px', sm: 'auto', md: '63px' },
                py: { xs: 0, sm: '8px', md: 0 },
                px: { xs: '16px', md: 0 },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                '@media print': { display: 'none' },
            }}
        >
            <Typography
                sx={{
                    fontFamily: 'Inter, sans-serif',
                    fontSize: { xs: '12px', sm: '14px', md: '18px' },
                    lineHeight: { xs: '16px', sm: '18px', md: '18px' },
                    letterSpacing: '-0.72px',
                    color: '#FFFFFF',
                    whiteSpace: { xs: 'normal', md: 'nowrap' },
                    textAlign: 'center',
                }}
            >
                <Box component="span" sx={{ fontWeight: 600, textDecoration: 'underline' }}>
                    {message.prefix}
                </Box>
                <Box component="span" sx={{ fontWeight: 400 }}>
                    {message.suffix}
                </Box>
            </Typography>
        </Box>
    );
});

export default AnnouncementBanner;
